import classNames from 'classnames';
import _isEqual from 'lodash/isEqual';
import React from 'react';
import { useDispatch } from 'react-redux';

import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { useFilters } from '@store/hooks/filters';
import { setOneFilter } from '@store/reducers/filters';

import { DEFAULT_UNKNOWN_TAG, FILTERS_NAME, REVIEWS_CATEGORY } from '../../../../constants/filters';

import styles from './empty-block.module.scss';

interface IEmptyBlockProps {
  attempt: number;
}

export const EmptyBlock = React.memo<IEmptyBlockProps>(({ attempt = 0 }) => {
  const isMobile = useIsMobile();
  const filters = useFilters();
  const dispatch = useDispatch();

  const changeReviewsCountFilter = () =>
    dispatch(
      setOneFilter({
        filterName: FILTERS_NAME.USER_RATING_TYPE,
        value: REVIEWS_CATEGORY.ALL,
      }),
    );

  const changeReviewTagFilter = () =>
    dispatch(
      setOneFilter({
        filterName: FILTERS_NAME.REVIEW_TAG,
        value: DEFAULT_UNKNOWN_TAG,
      }),
    );

  const changeLocationFilter = () => dispatch(setOneFilter({ filterName: FILTERS_NAME.LOCATION, value: null }));

  const getWhatToDoText = () => {
    if (filters.userRatingType !== REVIEWS_CATEGORY.ALL) {
      return (
        <>
          <br />
          Например,{' '}
          <Typography.Link onClick={changeReviewsCountFilter}>
            убрать ограничение по&nbsp;количеству отзывов
          </Typography.Link>
        </>
      );
    } else if (!_isEqual(filters.reviewTag, DEFAULT_UNKNOWN_TAG)) {
      return (
        <>
          <br />
          Например, <Typography.Link onClick={changeReviewTagFilter}>убрать фильтр по продукту</Typography.Link>
        </>
      );
    } else if (filters.location !== null) {
      return (
        <>
          <br />
          Например, <Typography.Link onClick={changeLocationFilter}>убрать фильтр по городу</Typography.Link>
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={classNames(styles.block)}>
      <img src={'/rating-assets/nothing-found.svg'} alt={''} />
      {attempt > 1 ? (
        <>
          <Typography.Heading level={isMobile ? 5 : 4} className={styles.heading}>
            Всё равно ничего не найдено :(
          </Typography.Heading>
          <Typography.Text size={14} className={styles.text}>
            К сожалению, по&nbsp;вашим параметрам ничего не&nbsp;найдено, попробуйте изменить&nbsp;их
            <br />
          </Typography.Text>
        </>
      ) : (
        <>
          <Typography.Heading level={isMobile ? 5 : 4} className={styles.heading}>
            Ничего не найдено :(
          </Typography.Heading>
          <Typography.Text size={14} className={styles.text}>
            К сожалению, по&nbsp;вашим параметрам ничего не&nbsp;найдено, попробуйте изменить&nbsp;их
            <br />
            {getWhatToDoText()}
          </Typography.Text>
        </>
      )}
    </div>
  );
});
